import React, { useState, useMemo } from 'react'
import { ActionSheet } from 'react-vant'
import { useTranslation } from 'react-i18next'

interface IdentificationTypeSelectorProps {
    value: string
    onChange: (value: string) => void
    placeholder?: string
    options: Array<{ value: string; label: string }>
}

const IdentificationTypeSelector: React.FC<IdentificationTypeSelectorProps> = ({
    value,
    onChange,
    placeholder,
    options
}) => {
    const { t } = useTranslation()
    const [visible, setVisible] = useState(false)

    // 获取选中的证件类型
    const selectedType = useMemo(() => {
        return options.find(option => option.value === value)
    }, [options, value])

    // 转换为 ActionSheet 的 actions 格式
    const actions = useMemo(() => {
        return options.map(option => ({
            name: option.label,
            value: option.value,
            className: value === option.value ? 'text-blue-600 font-medium' : ''
        }))
    }, [options, value])

    // 处理选择
    const handleSelect = (action: any) => {
        onChange(action.value)
        setVisible(false)
    }

    return (
        <>
            <div
                onClick={() => setVisible(true)}
                className="w-full px-4 h-11.5 border-[0.5px] border-[#808080] border-solid rounded-2.5 bg-white cursor-pointer flex items-center justify-between"
            >
                <span className={`text-3 ${selectedType ? 'text-black' : 'text-[#1A1A1A]/30'}`}>
                    {selectedType ? selectedType.label : placeholder}
                </span>
                <img src="/icon/select-down.svg" alt="" />
            </div>

            <ActionSheet
                visible={visible}
                onCancel={() => setVisible(false)}
                onSelect={handleSelect}
                actions={actions}
                cancelText={t('取消')}
                description={t('请选择证件类型')}
                closeOnClickAction
                safeAreaInsetBottom
            />
        </>
    )
}

export default IdentificationTypeSelector
